import {PROJECT_RECEIVE_AVAILABLE_PROJECTS, PROJECT_SELECT_PROJECT} from "../config/actions";

let defaultState = {
    selectedProject: null,
    availableProjects: []
};

const projectReducer = (state = defaultState, action) => {
    switch (action.type) {
        case PROJECT_RECEIVE_AVAILABLE_PROJECTS:
            return Object.assign({}, state, {
                availableProjects: action.data.availableProjects,
                selectedProject: action.data.availableProjects.find((project) => {
                    if(state.selectedProject) {
                        return project.id === state.selectedProject.id
                    } else {
                        return project.current === true
                    }
                })
            });
        case PROJECT_SELECT_PROJECT:
            return Object.assign({}, state, {
                selectedProject: state.availableProjects.find((project) => {
                    return project.id === parseInt(action.data.projectId)
                })
            });
        default:
            return state;
    }
};

export default projectReducer;
